import qs from "qs";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "react-use";

import { wipeCaseDetail } from "shared/actions/caseDetailActions";
import { wipeSlideDetail } from "shared/actions/slideDetailActions";
import { QueueEnum, userDefaultQueue } from "shared/reducers/casesReducer";

import CaseList from "components/viewerLists/caseList/CaseList";
import ApplicationState from "store/ApplicationState";
import { AppDispatch } from "store/store";

import ErrorPane from "../ErrorPane";
import Layout from "../Layout";

const CasesPage = (_props: any) => {
  const dispatch = useDispatch<AppDispatch>();

  const { error = undefined } = useSelector(
    ({ cases }: ApplicationState) => cases
  );
  const { user = undefined } = useSelector(
    ({ auth }: ApplicationState) => auth
  );
  const features = useSelector(({ sys }: ApplicationState) => sys.features);

  const navigate = useNavigate();

  let queue = _props.queue || userDefaultQueue(user);

  const [defaultCaseListView, setDefaultCaseListView] = useLocalStorage(
    "caselist_default_view",
    queue
  );

  useEffect(() => {
    const filterParams = qs.stringify(
      qs.parse(window.location.search, { ignoreQueryPrefix: true })
    );
    navigate(`/${defaultCaseListView}?${filterParams}`, { replace: true });
  }, []);

  useEffect(() => {
    dispatch(wipeCaseDetail());
    dispatch(wipeSlideDetail());
  }, [dispatch]);

  let status:
    | "active"
    | "working"
    | "flagged"
    | "finalized"
    | "ordered"
    | null = null;
  let includeSignedOut: boolean | null = null;
  if (queue === QueueEnum.Working) {
    defaultCaseListView !== QueueEnum.Working &&
      setDefaultCaseListView(QueueEnum.Working);
    status = "working";
  }
  if (queue === QueueEnum.Finalized) {
    status = "finalized";
    defaultCaseListView !== QueueEnum.Finalized &&
      setDefaultCaseListView(QueueEnum.Finalized);
  }
  if (queue === QueueEnum.Active) {
    status = "active";
    defaultCaseListView !== QueueEnum.Active &&
      setDefaultCaseListView(QueueEnum.Active);
  }
  if (queue === QueueEnum.Ordered) {
    status = "ordered";
    defaultCaseListView !== QueueEnum.Ordered &&
      setDefaultCaseListView(QueueEnum.Ordered);
  }
  if (queue === QueueEnum.Screen) {
    defaultCaseListView !== QueueEnum.Screen &&
      setDefaultCaseListView(QueueEnum.Screen);
  }
  if (queue === QueueEnum.Screened) {
    defaultCaseListView !== QueueEnum.Screened &&
      setDefaultCaseListView(QueueEnum.Screened);
  }
  if (queue === QueueEnum.Preliminary) {
    defaultCaseListView !== QueueEnum.Preliminary &&
      setDefaultCaseListView(QueueEnum.Preliminary);
  }
  if (queue === QueueEnum.All) {
    status = null;
    defaultCaseListView !== QueueEnum.All &&
      setDefaultCaseListView(QueueEnum.All);
  }

  return (
    <Layout
      requisitionsNav={
        user?.has_access_to_report_list && features?.clinicRequisitionsList
      }
      reportsNav={
        user?.has_access_to_report_list && features?.clinicReportsList
      }
    >
      <Helmet>
        <title>Cases - Pathology Watch</title>
      </Helmet>
      {error ? (
        <ErrorPane error={error} />
      ) : (
        <CaseList
          queue={queue as QueueEnum}
          includeSignedOut={includeSignedOut}
          status={status}
        />
      )}
    </Layout>
  );
};

export default CasesPage;
